"use client";

import { OpenEndedBlock } from "@/lib/utils/lomdaV3/types";
import { WidthControl } from "./blockAppearance";

/** Topbar for the OpenEndedBlock. Editing is inline on the block, so the topbar only
 *  carries the shared width control. */
export default function OpenEndedSettings({ block }: { block: OpenEndedBlock }) {
    return (
        <div className="flex items-center gap-3">
            <WidthControl blockId={block.id} />
        </div>
    );
}
